import { Checkbox, Select, Skeleton } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { TOGGLE_SELECT_MEDICATION_PRESCRIPTION } from "../../../actions/type";
import { AssetStore } from "../../../assets/AssetsStore";
import { BlackAdd, BlueAdd, ClockSmall } from "../../../assets/Logos/Icons";
import PrescriptionDropDown from "../../PrescriptionDropdown/PrescriptionDropDown";
import AddMedicineModal from "../../PrintPrescription/Components/Modals/AddMedicineModal/AddMedicineModal";
import { PrescriprionContext } from "../../PrintPrescription/PrintPrescription";
import Searchbox from "../SearchBox/Searchbox";
import styles from "./index.module.scss";
import FreequancyCustomisationModal from "../../PrintPrescription/Components/Modals/FreequancyCustomisationModal/FreequancyCustomisationModal";

function MedicationBox({
  name,
  addTitle,
  initialData,
  selectedData,
  handleSearch,
  handleAdd,
  toggle,
  detailedData,
}) {
  const [isOpen, setOpne] = useState(false);
  const [isAddOpen, setAddOpen] = useState(false);
  const [selected, setSelected] = useState(false);
  const [searchValues, setSearchValues] = useState([]);
  const [detailKeys, setDetailKeys] = useState([]);
  const [currentDetailData, setCurrentDetailData] = useState({});
  const [selectedMedicineId, setSelectedMedicineId] = useState(null);
  const [selectedMedicineGenericname, setSelectedMedicineGenericName] =
    useState(null);
  const [selectedMedicData, setSelectedMedicData] = useState([]);
  const [selectedDetailData, setSelectedDetailData] = useState({});
  const [customFreequancies, setCustomFreequancies] = useState(["", "", ""]);
  const [addCustomFreequancyModal, setAddCustomFreequancyModal] =
    useState(false);
  const [timing, setTiming] = useState({
    l1: ["1-0-1", "1-1-1", "1-0-0", "0-0-1", "0-1-1", "1-1-0"],
    l2: ["Before Food", "After Food", "Empty Stomach", "Bedtime", "SOS"],
    l3: [],
    l4: [],
  });
  const { wholeData, handleWholeData } = useContext(PrescriprionContext);

  useEffect(() => {
    if (detailedData?.length) {
      setDetailKeys(Object.keys(detailedData[0]));
      setCurrentDetailData(detailedData[0]);
    }
    if (selectedMedicineId) {
      setSelectedDetailData(
        selectedMedicData.filter((item) => item.name === selectedMedicineId)[0]
          ?.detailData || {}
      );
    }
  }, [selectedMedicineId, detailedData]);

  const [sinceOption, setSinceOption] = useState([
    { label: "1d", value: "1d" },
    { label: "2d", value: "2d" },
    { label: "3d", value: "3d" },
    { label: "4d", value: "4d" },
    { label: "5d", value: "5d" },
    { label: "6d", value: "6d" },
    { label: "week", value: "week" },
    { label: "10d", value: "10d" },
  ]);

  const dispatch = useDispatch();

  const quickQuantity = ["1", "1.5", "2.5", "4", "5", "7.5", "10"];
  let units = ["GRAMS", "MCG", "MG", "MG/ML", "ML", "NUM", "μm", "PERCENTAGE"];

  const freequancy = {
    l1: [
      "1d",
      "2d",
      "3d",
      "4d",
      "5d",
      "1w",
      "10d",
      "2w",
      "12d",
      "3w",
      "Once",
      "Twice",
      "Thrice",
      "4 times",
    ],
    l2: [],
    l3: [],
  };

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  useEffect(() => {
    setSearchValues(createSearchOptionsWithData(initialData));
  }, [initialData]);

  const handleAddSubmit = (name) => {
    handleAdd(name);
    setSelectedMedicineId(name.name);
    setSelectedMedicineGenericName(name.genericname);
    handleSelectData(name);
    setSelected(() => name);
    setOpne(true);
  };

  const handleItemClick = (name) => {
    setSelectedMedicineId(name.name);
    setSelectedMedicineGenericName(name.genericname);
    if (
      selectedMedicData.filter((item) => item.name === name.name).length > 0
    ) {
      //If the data is already selected
      console.info("here");
      handleUnSelectData(name);
    } else {
      //If the data is not already selected
      console.info("here else", name);
      handleSelectData(name);
    }

    if (isSelected(name)) {
      if (isOpen) {
        setOpne(false);
      } else {
        setSelected(() => name);
        setOpne(true);
      }
    } else {
      toggle(name);
      setSelected(() => name);
      setOpne(true);
    }
  };

  const handleItemClickSelected = (name) => {
    setSelectedMedicineId(name.name);
    setSelectedMedicineGenericName(name.genericname);
    if (isSelected(name) && selected?.name === name) {
      if (isOpen) {
        setOpne(false);
      } else {
        setSelected(() => name);
        setOpne(true);
      }
    } else {
      setSelected(() => name);
      setOpne(true);
    }
  };

  const isSelected = (params) => {
    let { name } = params;
    let data = selectedMedicData;
    if (data && data.length > 0) {
      let res = data.filter((e) => e.name === name);

      return res && res.length > 0;
    }
  };

  const pushToWholeData = (key, data) => {
    handleWholeData(key, data);
  };

  useEffect(() => {
    if (selectedMedicData.length > 0) {
      pushToWholeData("medications", selectedMedicData);
    }
  }, [selectedMedicData]);

  const handleSubmissionData = (items) => {
    setSelectedMedicData(items);
  };

  useEffect(() => {
    if (wholeData.medications !== selectedMedicData) {
      handleSubmissionData(wholeData.medications);
      handleSubmissionDatacustom(wholeData.medications);
      if (wholeData.medications.length > 0) {
        setSelectedMedicineId(wholeData.medications[0].name);
        setSelectedMedicineGenericName(wholeData.medications[0].genericname);
        setOpne(true);
      }
    }
  }, [wholeData.medications]);

  const handleSubmissionDatacustom = (items) => {
    if (items.length > 0) {
      items.map((eachFreequancy, key) => {
        console.info(
          "eachFreequancy",
          eachFreequancy?.detailData?.default_timing
        );
        if (eachFreequancy?.detailData?.default_timing != undefined) {
          if (
            !timing.l1.includes(
              eachFreequancy?.detailData?.default_timing.join(" ")
            )
          ) {
            let _l1 = [
              ...timing.l1,
              eachFreequancy?.detailData?.default_timing.join(" "),
            ];
            setTiming({ ...timing, l1: _l1 });
            //handleSubChange({ key: "default_timing", value:selectedDetailData.default_timing});
          }
        }
      });
    }
  };
  const createSearchOptionsWithData = (data) => {
    if (data && data.length > 0) {
      let result = [];
      data.map((e) => result.push({ label: e?.name, value: e?.name }));
      return result;
    } else {
      return [];
    }
  };

  const isSubSelected = (key, value) => {
    if (selectedDetailData && Object.keys(selectedDetailData).includes(key)) {
      return selectedDetailData[key].includes(value);
    } else {
      return false;
    }
  };

  const getSubValue = (key) => {
    if (selectedDetailData?.length) {
      let indexData = selectedDetailData?.filter((e) => e.name === selected)[0];
      return indexData ? indexData?.detailData[key] : "";
    }
    return "";
  };

  const handleSelectData = (data) => {
    console.log("{data}");
    setSelectedMedicData([...selectedMedicData, data]);
  };

  const handleUnSelectData = (data) => {
    setSelectedMedicData(
      selectedMedicData.filter((item) => item.name !== data.name)
    );
  };

  let handleAddIconClick = (e, name) => {
    if (
      selectedMedicData.filter((item) => item.name === name.name).length > 0
    ) {
      handleUnSelectData(name);
    } else {
      handleSelectData(name);
    }
    setSelectedMedicineId(name.name);
    setSelectedMedicineGenericName(name.genericname);
    e.stopPropagation();
    toggle(name);
    setOpne(false);
  };

  let isNumber = (e) => {
    let value = e?.target?.value;
    var rgx = /^[0-9]*\.?[0-9]*$/;
    return value?.match(rgx);
  };

  let isNumberAndText = (e) => {
    let value = e?.target?.value;
    var rgx = /^[A-Za-z0-9]*$/;
    return value?.match(rgx);
  };

  const isAnArray = (data) => {
    return Array.isArray(data);
  };

  const handleSearchBox = (value) => {
    let _item = initialData.filter((e) => e.name == value)[0];
    let _isSelected = selectedMedicData.filter((e) => e.name == value)[0];

    if (!_isSelected) {
      // toggle(_item);
      setSelectedMedicineId(_item.name);
      setSelectedMedicineGenericName(_item.genericname);
      handleSearch(_item);
      handleSelectData(_item);
    }

    setSelected(() => _item);
    setOpne(true);

    setSearchValues(createSearchOptionsWithData(initialData));
  };

  const isInSearch = (e, data) => {
    for (let i = 0; i < e.length; i++) {
      if (e[i].toLowerCase() !== data?.name[i].toLowerCase()) {
        return false;
      }
    }
    return true;
  };

  const handleOnSearch = (e) => {
    if (initialData && initialData.length > 0 && e) {
      let filterData = initialData.filter((option) => isInSearch(e, option));
      setSearchValues(createSearchOptionsWithData(filterData));
    } else setSearchValues([]);
  };

  const handleOnTimingCheck = (value) => {
    handleSubChange({ key: "default_timing_custom", value });
  };

  const handleAutoCompleteOptions = (e) => {
    setSinceOption(sinceOption.filter((item) => item.name.indexOf(e) > -1));
  };

  const handleSubChange = ({ key, value }) => {
    console.info("handleSubChange", key, value);
    let newSubmissionData = { ...selectedDetailData };
    const keys = Object.keys(newSubmissionData);
    if (!keys.length) {
      newSubmissionData = { [key]: [value] };
    } else if (keys.includes(key)) {
      if (newSubmissionData[key].includes(value)) {
        delete newSubmissionData[key];
      } else {
        newSubmissionData = { ...newSubmissionData, [key]: [value] };
      }
    } else {
      newSubmissionData = { ...newSubmissionData, [key]: [value] };
    }
    setSelectedDetailData(newSubmissionData ?? {});
  };

  const handleDetailDataSelection = () => {
    let temp = [...selectedMedicData];
    const currentIndex = temp.findIndex(
      (item) => item.name === selectedMedicineId
    );
    temp[currentIndex] = {
      ...temp[currentIndex],
      detailData: selectedDetailData,
    };
    setSelectedMedicData(temp);
  };

  useEffect(() => {
    if (selectedDetailData && Object.keys(selectedDetailData).length) {
      handleDetailDataSelection();
    }
  }, [selectedDetailData]);

  //Custom Freequancy functions..............................
  const manageAddCustomFreequancyModal = (flag) => {
    setAddCustomFreequancyModal(flag || false);
    setCustomFreequancies(["", "", ""]);
  };
  const handleAddCustomFreeauancy = () => {
    console.info("customFreequancies", customFreequancies);
    //setCustomFreequancies(["","",""]);
    setCustomFreequancies([...customFreequancies, ""]);
  };
  const handleRemoveCustomFreeauancy = () => {};
  const handleOnChangeFreequancyData = (e) => {
    console.info("handleOnChangeFreequancyData", customFreequancies);
    let _customFreequancies = customFreequancies.map((eachFreequancy, key) => {
      if (key === e?.key) return e?.value;
      else return eachFreequancy;
    });
    setCustomFreequancies(_customFreequancies);
  };

  const handleSaveCustomFreequancy = () => {
    manageAddCustomFreequancyModal();

    let _l1 = [
      ...timing.l1,
      customFreequancies.filter((element) => element).join("-"),
    ];
    if (customFreequancies.some((value) => !!value)) {
      if (!timing.l1.includes(customFreequancies.join("-"))) {
        setTiming({ ...timing, l1: _l1 });
      }
      handleSubChange({
        key: "default_timing",
        value: customFreequancies.filter((element) => element).join("-"),
      });
      //handleItemClickSelected(customFreequancies.filter((element) => element).join('-'));
      setCustomFreequancies(["", "", ""]);
    }
  };

  return (
    <>
      <div className={styles.data_box_wrap}>
        <div className={styles.medication_box_container}>
          <div className={styles.header}>
            <div className={styles.searchBox}>
              <Searchbox
                value={selected}
                options={searchValues}
                onSelect={handleSearchBox}
                onSearch={handleOnSearch}
                placeholder="Search"
              />
            </div>

            <button
              className={styles.add_new_button}
              onClick={() => {
                setAddOpen(true);
              }}
            >
              <span>Add new</span>
              <BlackAdd />
            </button>
          </div>

          <div className={styles.body}>
            <div className={styles.caption}>
              <ClockSmall />
              {name}
            </div>

            <div className={styles.data_list_wrap}>
              {wholeData?.loadingMedications ? (
                <PageLoader />
              ) : (
                <>
                  <div className={styles.data_list}>
                    {initialData &&
                      initialData.length > 0 &&
                      initialData.map((each, key) => {
                        if (isSelected(each)) {
                          return (
                            <div
                              onClick={() => {
                                handleItemClickSelected(each);
                              }}
                              className={`${styles.data_list_item} ${
                                isSelected(each) &&
                                styles.data_list_item_selected
                              }`}
                              key={key}
                            >
                              <div>{each?.name}</div>

                              <div
                                onClick={(e) => {
                                  handleAddIconClick(e, each);
                                }}
                                className={`${styles.addIcon} ${
                                  !isSelected(each)
                                    ? styles.addIconSelected
                                    : styles.addIconNotSelected
                                }`}
                              >
                                <BlueAdd
                                  isSelected={isSelected(each)}
                                  scale={0.7}
                                />
                              </div>
                            </div>
                          );
                        }
                      })}
                  </div>

                  <div className={styles.data_list}>
                    {initialData &&
                      initialData.length > 0 &&
                      initialData.slice(0, 10).map((each, key) => {
                        if (!isSelected(each)) {
                          return (
                            <div
                              onClick={() => {
                                handleItemClick(each);
                              }}
                              className={`${styles.data_list_item} ${
                                isSelected(each) &&
                                styles.data_list_item_selected
                              }`}
                              key={key}
                            >
                              <div>{each?.name}</div>

                              <div
                                onClick={(e) => {
                                  handleAddIconClick(e, each);
                                }}
                                className={`${styles.addIcon} ${
                                  !isSelected(each)
                                    ? styles.addIconSelected
                                    : styles.addIconNotSelected
                                }`}
                              >
                                <BlueAdd
                                  isSelected={isSelected(each)}
                                  scale={0.7}
                                />
                              </div>
                            </div>
                          );
                        }
                      })}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        <div
          className={`${styles.options_container} ${
            isOpen
              ? styles.options_container_open
              : styles.options_container_close
          }`}
        >
          <div className={styles.option_item}>
            <div className={styles.item_list}>
              <div className={`${styles.item} ${styles.item_title}`}>
                {selectedMedicineId}
                {selectedMedicineGenericname != null ? (
                  <p>({selectedMedicineGenericname})</p>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>

          <div className={styles.option_item}>
            <div className={styles.caption}>Quantity</div>

            <div className={styles.form_item}>
              <input
                value={
                  selectedDetailData?.quantity?.length
                    ? selectedDetailData?.quantity[0]
                    : ""
                }
                onChange={(e) => {
                  isNumber(e) &&
                    handleSubChange({ key: "quantity", value: e.target.value });
                }}
                placeholder="Enter quantity"
                className={styles.form_item_input}
                type="text"
              />
              { console.log("🚀 ~ file: MedicationBoxbk.jsx:567 ~ selectedDetailData:", selectedDetailData)}
              <PrescriptionDropDown
                defaultPlaceH="Select Unit"
                value={
                  selectedDetailData?.quantity_messurment != undefined
                    ? selectedDetailData?.quantity_messurment[0]
                    : ""
                }
                onChange={(e) => {
                  handleSubChange({ key: "quantity_messurment", value: e });
                }}
                selectedData={"ml"}
                DataItem={units}
              />
            </div>

            <div className={styles.item_list}>
              {quickQuantity.map((each, key) => {
                return (
                  <div
                    key={key}
                    onClick={() => {
                      handleSubChange({ key: "quantity", value: each });
                    }}
                    className={`${styles.item} ${
                      isSubSelected("quantity", each) &&
                      styles.sub_item_selected
                    }`}
                  >
                    {each}
                  </div>
                );
              })}
            </div>
          </div>

          <div className={styles.option_item}>
            <div className={styles.caption}>Frequency</div>

            <div className={styles.item_list}>
              {timing.l1.map((each, key) => (
                <div
                  key={key}
                  onClick={() => {
                    handleSubChange({ key: "default_timing", value: each });
                  }}
                  className={`${styles.item} ${
                    isSubSelected("default_timing", each) &&
                    styles.sub_item_selected
                  }`}
                >
                  {each}
                </div>
              ))}

              <div
                // key={key}
                // onClick={() => {
                //   handleSubChange({ key: "default_timing", value: each });
                // }}
                onClick={() => {
                  manageAddCustomFreequancyModal(true);
                }}
                className={`${styles.item} ${
                  isSubSelected("default_timing", "Customize") &&
                  styles.sub_item_selected
                }`}
              >
                {"Customize"}
              </div>
            </div>

            <div className={styles.item_list}>
              {timing.l2.map((each, key) => {
                return (
                  <div key={key} className={styles.item_checkbox}>
                    <Checkbox
                      checked={isSubSelected("default_timing_custom", each)}
                      onChange={() => {
                        handleOnTimingCheck(each);
                      }}
                    />
                    {each}
                  </div>
                );
              })}
            </div>
          </div>

          <div className={styles.option_item}>
            <div className={styles.caption}>Duration</div>

            <div className={styles.form_item}>
              <input
                value={
                  selectedDetailData?.custom_duration?.length
                    ? selectedDetailData?.custom_duration[0]
                    : ""
                }
                onChange={(e) => {
                  isNumberAndText(e) &&
                    handleSubChange({
                      key: "custom_duration",
                      value: e.target.value,
                    });
                }}
                className={styles.form_item_input}
                type="text"
                placeholder="Enter custom duration"
              />
            </div>

            <div className={styles.item_list}>
              {freequancy.l1.map((each, key) => (
                <div
                  key={key}
                  onClick={() => {
                    handleSubChange({ key: "custom_duration", value: each });
                  }}
                  className={`${styles.item} ${
                    isSubSelected("custom_duration", each) &&
                    styles.sub_item_selected
                  }`}
                >
                  {each}
                </div>
              ))}
            </div>
            <div className={styles.item_list}>
              {freequancy.l2.map((each, key) => (
                <div
                  key={key}
                  onClick={() => {
                    handleSubChange({ key: "custom_duration", value: each });
                  }}
                  className={`${styles.item} ${
                    isSubSelected("custom_duration", each) &&
                    styles.sub_item_selected
                  }`}
                >
                  {each}
                </div>
              ))}
            </div>
            <div className={styles.item_list}>
              {freequancy.l3.map((each, key) => (
                <div
                  key={key}
                  onClick={() => {
                    handleSubChange({ key: "custom_duration", value: each });
                  }}
                  className={`${styles.item} ${
                    isSubSelected("custom_duration", each) &&
                    styles.sub_item_selected
                  }`}
                >
                  {each}
                </div>
              ))}
            </div>
          </div>

          <div className={styles.option_item}>
            <div className={styles.caption}>Note</div>

            <div className={styles.form_item}>
              <input
                value={
                  selectedDetailData?.note?.length
                    ? selectedDetailData?.note[0]
                    : ""
                }
                onChange={(e) => {
                  handleSubChange({ key: "note", value: e.target.value });
                }}
                className={styles.form_item_input}
                type="text"
                placeholder="Enter note here"
              />
            </div>
          </div>
        </div>
      </div>

      <FreequancyCustomisationModal
        freequancyList={customFreequancies}
        isOpen={addCustomFreequancyModal}
        handleClose={() => {
          manageAddCustomFreequancyModal(false);
        }}
        addFreequancy={handleAddCustomFreeauancy}
        removeFreequancy={handleRemoveCustomFreeauancy}
        onChangeData={handleOnChangeFreequancyData}
        onSave={handleSaveCustomFreequancy}
      />

      <AddMedicineModal
        onSubmit={(e) => {
          handleAddSubmit(e);
        }}
        title={addTitle ? addTitle : "Add new"}
        showModal={isAddOpen}
        hidemodal={() => {
          setAddOpen(false);
        }}
      />
    </>
  );
}

export default MedicationBox;

const PageLoader = () => {
  return (
    <div className="d-flex flex-row mt-3" style={{gap:15, flexWrap:"wrap"}}>
      {[...Array(10)].map(() => (
        <Skeleton.Button
          style={{width:"199px"}}
          active={true}
          size="large"
          shape={"round"}
         
        />
      ))}
    </div>
  );
};
